/* ════════════════════════════════════════════════════════════════
   POSTERARTE · posterarte.product.js
   Ficha de producto — JavaScript vanilla adaptado a Shopify
   Sin dependencias externas. Sin jQuery.
   ════════════════════════════════════════════════════════════════ */

(() => {
  'use strict';

  /* ─────────────────────────────────────────────
     GALERÍA DE IMÁGENES — slider vanilla (sin Swiper)
     CSS: .swiper-wrapper { display:flex; transition:transform }
          .swiper-slide  { flex: 0 0 100% }
     ───────────────────────────────────────────── */
  const initGallery = () => {
    const mainEl = document.getElementById('paGalleryMain');
    if (!mainEl || mainEl._paGalleryInit) return;
    mainEl._paGalleryInit = true;

    const wrapper   = mainEl.querySelector('.swiper-wrapper');
    const slides    = [...mainEl.querySelectorAll('.swiper-slide')];
    const thumbBtns = [...document.querySelectorAll('.pa-gallery-thumbs .pa-thumb')];
    const prevBtn   = mainEl.querySelector('.pa-gallery-prev');
    const nextBtn   = mainEl.querySelector('.pa-gallery-next');

    if (!wrapper || slides.length === 0) return;

    let current = 0;
    const count = slides.length;

    // EN BUCLE (Javi, 2026-10-13): pasada la ultima foto se vuelve a la primera, y
    // al reves. Antes las flechas se apagaban en los extremos y para volver a la
    // primera habia que deshacer el camino: con las 9 fotos de un pack, ocho clics.
    // La vuelta va SIN transicion: animada, pasaria todas las fotos por delante.
    const goTo = (idx) => {
      const vuelta = idx < 0 || idx > count - 1;
      current = ((idx % count) + count) % count;
      if (vuelta) wrapper.style.transition = 'none';
      wrapper.style.transform = `translateX(-${current * 100}%)`;
      if (vuelta) {
        void wrapper.offsetWidth; // aplica el salto antes de devolver la transicion
        wrapper.style.transition = '';
      }

      // Sync thumbnails
      thumbBtns.forEach((t, i) => {
        const active = i === current;
        t.classList.toggle('is-active', active);
        // aria-current y no aria-selected: las miniaturas ya no son pestañas (2026-11-02).
        if (active) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });

      // Scroll thumbnail into view on mobile
      if (window.matchMedia('(max-width: 1023px)').matches && thumbBtns[current]) {
        thumbBtns[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      // Con una sola foto no hay a donde ir; con mas, las flechas nunca se apagan.
      if (prevBtn) prevBtn.classList.toggle('is-disabled', count < 2);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', count < 2);
    };

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
    thumbBtns.forEach((btn, i) => btn.addEventListener('click', () => goTo(i)));

    // Touch/swipe — prev/next are hidden on mobile so this is the only nav method
    let touchStartX = 0;
    let touchStartY = 0;
    let gestoConDosDedos = false; // un pellizco nunca cambia de foto
    mainEl.addEventListener('touchstart', e => {
      if (e.touches.length > 1) { gestoConDosDedos = true; return; }
      gestoConDosDedos = false;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    mainEl.addEventListener('touchend', e => {
      if (gestoConDosDedos) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      // Only trigger on clearly horizontal swipes (>40px, more horizontal than vertical)
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    // PELLIZCO SOLO SOBRE LA FOTO (Javi, 2026-10-25). El pellizco nativo amplia la
    // pagina entera, y Javi quiere que se amplie solo la obra: por eso el CSS deja
    // touch-action en pan-y (sin pinch-zoom) y el gesto se hace aqui. Mientras hay
    // dos dedos, la foto escala dentro de su marco (overflow: hidden) siguiendo el
    // punto medio, y al levantarlos vuelve a su tamaño, como en Instagram. La version
    // de 3000 px (data-zoom-src) se pide solo al primer pellizco de cada foto.
    const ESCALA_MAX = 4;
    let pellizco = null;
    const distancia = (t) => Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
    const puntoMedio = (t) => ({ x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 });

    mainEl.addEventListener('touchstart', e => {
      if (e.touches.length !== 2) return;
      const img = slides[current].querySelector('.pa-gallery-main__img');
      if (!img) return;
      const grande = slides[current].querySelector('.pa-zoom').dataset.zoomSrc;
      if (grande && !img.dataset.paGrande) {
        img.dataset.paGrande = '1';
        const pre = new Image();
        pre.onload = () => { img.removeAttribute('srcset'); img.src = grande; };
        pre.src = grande;
      }
      const r = img.getBoundingClientRect();
      const m = puntoMedio(e.touches);
      img.style.transformOrigin = `${m.x - r.left}px ${m.y - r.top}px`;
      img.classList.remove('is-soltando');
      img.classList.add('is-pellizcando');
      pellizco = { img, d0: distancia(e.touches), m0: m };
    }, { passive: true });

    mainEl.addEventListener('touchmove', e => {
      if (!pellizco || e.touches.length !== 2) return;
      e.preventDefault(); // ni scroll ni zoom de pagina mientras se pellizca la foto
      const escala = Math.min(ESCALA_MAX, Math.max(1, distancia(e.touches) / pellizco.d0));
      const m = puntoMedio(e.touches);
      pellizco.img.style.transform =
        `translate(${m.x - pellizco.m0.x}px, ${m.y - pellizco.m0.y}px) scale(${escala})`;
    }, { passive: false });

    const soltar = () => {
      if (!pellizco) return;
      const img = pellizco.img;
      pellizco = null;
      img.classList.remove('is-pellizcando');
      img.classList.add('is-soltando');
      img.style.transform = '';
      // Con un temporizador y no con transitionend: si la foto ya estaba a escala 1
      // no hay transicion, el evento no llega y la clase se quedaria puesta.
      setTimeout(() => img.classList.remove('is-soltando'), 260);
    };
    mainEl.addEventListener('touchend', e => { if (e.touches.length < 2) soltar(); }, { passive: true });
    mainEl.addEventListener('touchcancel', soltar, { passive: true });

    goTo(0); // initialise position
  };

  /* ─────────────────────────────────────────────
     VARIANT PICKER — conectado a Shopify Cart API
     ───────────────────────────────────────────── */
  const initVariantPicker = () => {
    const pills = document.querySelectorAll('.pa-pill');
    const variantInput = document.getElementById('paVariantId');
    const priceEl = document.getElementById('paPrice');
    // Los dos precios de botón ya no se leen aquí: los resuelve
    // refrescarPrecioBotones(), que es quien sabe la cantidad.
    const stickySizeEl = document.getElementById('paStickySize');
    const ctaAdd = document.getElementById('paCtaAdd');
    const stickyBtn = document.getElementById('paStickyBtn');

    if (!pills.length) return;

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        if (pill.disabled) return;

        // Actualizar estado visual
        pills.forEach(p => {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');

        const variantId = pill.dataset.variantId;
        const price = pill.dataset.price;
        const title = pill.dataset.title;

        // Actualizar input hidden del form
        if (variantInput) variantInput.value = variantId;

        // Actualizar precio visible
        if (priceEl) priceEl.textContent = price;

        // Actualizar sticky cart. La barra muestra la etiqueta DIN (A4, A3…)
        // cuando el formato la tiene, igual que la rejilla de colección; el
        // dato lo calcula Liquid en data-sticky-label, para que la regla viva
        // en un solo sitio (snippet posterarte-etiqueta-formato).
        if (stickySizeEl) stickySizeEl.textContent = pill.dataset.stickyLabel || title;

        // Los precios de los DOS botones —el CTA y el de la barra— los pinta
        // refrescarPrecioBotones(), que multiplica por la cantidad. Antes se
        // escribían aquí el unitario a pelo, y eso borraba la multiplicación
        // en cuanto se cambiaba de talla con la cantidad ya subida.
        // Se llama después de que la pastilla tenga .is-active, que es de
        // donde lee el precio unitario.
        refrescarPrecioBotones();

        // Fetch variante para verificar disponibilidad
        fetch(`/variants/${variantId}.js`)
          .then(r => r.json())
          .then(variant => {
            const available = variant.available;
            if (ctaAdd) {
              ctaAdd.disabled = !available;
              const textSpan = ctaAdd.querySelector('span:first-child');
              if (textSpan) textSpan.textContent = available ? 'LO QUIERO' : 'AGOTADO';
            }
            if (stickyBtn) stickyBtn.disabled = !available;
          })
          .catch(() => {});
      });
    });

    /* TECLADO (2026-11-02, alerta 58). Las pastillas se anuncian como
       role=radio y el patron ARIA promete flechas y una sola parada de
       tabulacion. Esto solo mueve el foco y llama a click() de la pastilla
       destino: la seleccion, el precio y el carrito siguen siendo los del
       manejador de arriba, sin una linea duplicada. Si este bloque fallara, las
       pastillas siguen funcionando como botones con Tab e Intro. */
    const activas = () => Array.from(pills).filter(p => !p.disabled);
    const fijarTabindex = () => {
      const marcada = Array.from(pills).find(p => p.classList.contains('is-active')) || activas()[0];
      pills.forEach(p => p.setAttribute('tabindex', p === marcada ? '0' : '-1'));
    };
    fijarTabindex();
    pills.forEach(pill => {
      pill.addEventListener('click', fijarTabindex);
      pill.addEventListener('keydown', (e) => {
        const paso = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!paso) return;
        const lista = activas();
        const i = lista.indexOf(pill);
        if (i < 0 || !lista.length) return;
        e.preventDefault();
        const destino = lista[(i + paso + lista.length) % lista.length];
        destino.focus();
        destino.click();
      });
    });
  };

  /* ─────────────────────────────────────────────
     PRECIO DE LOS BOTONES = unitario × cantidad

     El precio GRANDE (#paPrice) NO se toca: es el precio unitario del
     producto, el mismo que sale en la rejilla de colección y en el schema, y
     multiplicarlo dejaría dos cifras distintas para la misma lámina. Lo que sí
     se multiplica es el precio que vive DENTRO de un botón de compra —el del
     CTA y el de la barra flotante—, porque ahí no se lee como «lo que cuesta
     esta lámina» sino como «lo que me van a cobrar si pulso». Lo detectó Javi
     el 2026-09-03: subía la cantidad y no se movía ningún precio.

     El formato de moneda viene de Liquid en data-money-format. Adivinarlo
     desde JS es cómo se acaba sirviendo «74.70 €» donde toca «74,70 €».
     ───────────────────────────────────────────── */
  const formatearDinero = (cents, formato) => {
    // Réplica de money_without_trailing_zeros: sin decimales cuando son cero.
    const conDecimales = cents % 100 !== 0;
    const entero = Math.floor(Math.abs(cents) / 100);
    const dec = String(Math.abs(cents) % 100).padStart(2, '0');

    const agrupar = (n, sep) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const pieza = {
      amount: () => agrupar(entero, ',') + (conDecimales ? '.' + dec : ''),
      amount_no_decimals: () => agrupar(entero, ','),
      amount_with_comma_separator: () => agrupar(entero, '.') + (conDecimales ? ',' + dec : ''),
      amount_no_decimals_with_comma_separator: () => agrupar(entero, '.'),
    };
    // Si el formato no llega o no trae marcador, se devuelve la cifra a secas
    // antes que una cadena rota.
    if (!formato || !/\{\{\s*\w+\s*\}\}/.test(formato)) return pieza.amount_with_comma_separator();
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, clave) =>
      (pieza[clave] || pieza.amount)());
  };

  const refrescarPrecioBotones = () => {
    const ctaPriceEl = document.getElementById('paCtaPrice');
    const stickyPriceEl = document.getElementById('paStickyPrice');
    if (!ctaPriceEl) return;

    // El unitario sale de la pastilla activa; sin pastillas —producto de una
    // sola variante— del atributo que dejó Liquid.
    const activa = document.querySelector('.pa-pill.is-active');
    const unit = parseInt(activa?.dataset.priceCents || ctaPriceEl.dataset.unitCents || '0', 10);
    if (!unit) return;

    const qty = parseInt(document.getElementById('paQtyInput')?.value || '1', 10) || 1;
    const total = formatearDinero(unit * qty, ctaPriceEl.dataset.moneyFormat);
    ctaPriceEl.textContent = '· ' + total;
    if (stickyPriceEl) stickyPriceEl.textContent = total;
  };

  /* ─────────────────────────────────────────────
     CANTIDAD
     ───────────────────────────────────────────── */
  const initQty = () => {
    const input = document.getElementById('paQtyInput');
    const display = document.getElementById('paQtyDisplay');
    const btns = document.querySelectorAll('.pa-qty__btn');

    if (!input || !btns.length) return;

    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        const delta = parseInt(btn.dataset.q, 10);
        const current = parseInt(input.value, 10) || 1;
        const next = Math.max(1, Math.min(99, current + delta));
        input.value = next;
        if (display) display.textContent = next;
        refrescarPrecioBotones();
      });
    });
  };

  /* ─────────────────────────────────────────────
     AÑADIR AL CARRITO — Shopify Cart API AJAX
     ───────────────────────────────────────────── */
  const initAddToCart = () => {
    const form = document.getElementById('pa-product-form');
    const ctaAdd = document.getElementById('paCtaAdd');
    const stickyBtn = document.getElementById('paStickyBtn');

    if (!form || !ctaAdd) return;
    if (form._paATCInit) return; // guard: script loaded twice → prevent duplicate listeners
    form._paATCInit = true;

    let isAddingToCart = false;

    const handleAddToCart = async (e) => {
      if (e) e.preventDefault();
      if (isAddingToCart) return;
      isAddingToCart = true;

      const variantId = parseInt(document.getElementById('paVariantId')?.value, 10);
      const qty = parseInt(document.getElementById('paQtyInput')?.value || '1', 10);

      if (!variantId) {
        isAddingToCart = false;
        return;
      }

      const textSpan = document.getElementById('paCtaText');
      const originalText = textSpan ? textSpan.textContent : 'LO QUIERO';
      if (textSpan) textSpan.textContent = 'AÑADIENDO…';
      ctaAdd.disabled = true;

      const cartDrawer = document.querySelector('cart-drawer');
      const sectionIds = cartDrawer?.getSectionsToRender
        ? cartDrawer.getSectionsToRender().map(s => s.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      // FormData es el único formato que Shopify acepta para el parámetro "sections"
      // (el JSON body no lo parsea — mismo enfoque que product-form.js de Ella)
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', qty);
      // Formato correcto: string CSV — idéntico a product-form.js de Ella (línea 123)
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.description || 'Error al añadir');
        }

        const data = await res.json();

        // ── STEP 1: eliminar is-empty de ambos elementos antes de abrir ───────
        // renderContents solo limpia .drawer__inner (que nunca tiene is-empty).
        // La clase queda en <cart-drawer> y <cart-drawer-items>, lo que activa
        // dos reglas CSS: grid-template-rows:1fr (colapsa contenido) y display:none.
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
          const drawerItems = cartDrawer.querySelector('cart-drawer-items');
          if (drawerItems) drawerItems.classList.remove('is-empty');
        }

        // ── STEP 2: garantizar HTML de secciones via Section Rendering API ────
        // /cart/add.js puede devolver data.sections vacío o undefined si Shopify
        // no reconoce el parámetro sections en esa petición. Hacemos un GET
        // separado a /?sections= que siempre retorna HTML actualizado.
        let dataWithSections = data;
        if (cartDrawer) {
          try {
            const sectionIds = (cartDrawer.getSectionsToRender?.() ?? [
              { id: 'cart-drawer' }, { id: 'cart-icon-bubble' }
            ]).map(s => s.id);

            const sectionsRes = await fetch(
              `/?sections=${sectionIds.join(',')}`,
              { cache: 'no-store' }
            );
            if (sectionsRes.ok) {
              const freshSections = await sectionsRes.json();
              dataWithSections = { ...data, sections: freshSections };
            }
          } catch (_) { /* mantener data original si el fetch falla */ }
        }

        // ── STEP 3: renderizar y abrir ────────────────────────────────────────
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(dataWithSections);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        // Resetear cantidad a 1 tras añadir con éxito
        const qtyInput = document.getElementById('paQtyInput');
        const qtyDisplay = document.getElementById('paQtyDisplay');
        if (qtyInput) qtyInput.value = '1';
        if (qtyDisplay) qtyDisplay.textContent = '1';

        // Actualizar burbuja del carrito en el header — independiente de cartDrawer
        // Dawn: <a id="cart-icon-bubble"><div class="cart-count-bubble">
        //          <span aria-hidden="true">N</span>
        //          <span class="visually-hidden">N artículos</span>
        //        </div></a>
        try {
          const cartRes = await fetch('/cart.js', { cache: 'no-store' });
          const cartData = await cartRes.json();
          const count = cartData.item_count;
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            const visSpan  = bubble.querySelector('.cart-count-bubble span[aria-hidden]');
            const a11ySpan = bubble.querySelector('.cart-count-bubble .visually-hidden');
            if (visSpan)  visSpan.textContent  = count;
            if (a11ySpan) a11ySpan.textContent = count + (count === 1 ? ' artículo' : ' artículos');
          }
        } catch (_) { /* no bloquear el flujo si falla el fetch del carrito */ }

        if (textSpan) textSpan.textContent = '✓ AÑADIDO';
        setTimeout(() => {
          if (textSpan) textSpan.textContent = originalText;
          ctaAdd.disabled = false;
        }, 1800);
        isAddingToCart = false;

      } catch (err) {
        console.error('Cart error:', err);
        if (textSpan) textSpan.textContent = 'ERROR';
        setTimeout(() => {
          if (textSpan) textSpan.textContent = originalText;
          ctaAdd.disabled = false;
        }, 2000);
        isAddingToCart = false;
      }
    };

    // CTA principal — interceptar submit del form (stopImmediatePropagation evita doble disparo)
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleAddToCart(e);
    });

    // Botón sticky — reutiliza el mismo handler
    if (stickyBtn) {
      stickyBtn.addEventListener('click', handleAddToCart);
    }
  };

  /* ─────────────────────────────────────────────
     FAQs — ACORDEÓN
     ───────────────────────────────────────────── */
  const initFaqs = () => {
    const faqBtns = document.querySelectorAll('.pa-faq__q');
    if (!faqBtns.length) return;
    // Guard: si el script se carga dos veces, evitar registrar listeners duplicados
    // que se cancelarían mutuamente en cada clic
    const container = document.querySelector('.pa-faqs');
    if (!container || container._paFaqsInit) return;
    container._paFaqsInit = true;

    // El navegador revela un panel hidden="until-found" cuando el usuario lo
    // encuentra con Ctrl+F, y dispara beforematch justo antes. Hay que
    // sincronizar clase y aria, o el boton se queda diciendo "cerrado".
    faqBtns.forEach(btn => {
      const cuerpo = btn.closest('.pa-faq').querySelector('.pa-faq__body');
      if (cuerpo) {
        cuerpo.addEventListener('beforematch', () => {
          document.querySelectorAll('.pa-faq').forEach(f => {
            f.classList.remove('is-open');
            f.querySelector('.pa-faq__q').setAttribute('aria-expanded', 'false');
            const o = f.querySelector('.pa-faq__body');
            if (o && o !== cuerpo) o.setAttribute('hidden', 'until-found');
          });
          btn.closest('.pa-faq').classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        });
      }
      btn.addEventListener('click', () => {
        const faq = btn.closest('.pa-faq');
        const body = faq.querySelector('.pa-faq__body');
        const isOpen = faq.classList.contains('is-open');

        // Cerrar todos
        document.querySelectorAll('.pa-faq').forEach(f => {
          f.classList.remove('is-open');
          f.querySelector('.pa-faq__q').setAttribute('aria-expanded', 'false');
          const b = f.querySelector('.pa-faq__body');
          if (b) b.setAttribute('hidden', 'until-found');
        });

        // Abrir el clickado si estaba cerrado
        if (!isOpen) {
          faq.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (body) body.removeAttribute('hidden');
        }
      });
    });
  };

  /* ─────────────────────────────────────────────
     STICKY CART — IntersectionObserver

     Vigila la fila del botón de compra (.pa-buy-row), no el hero entero.
     Hasta el 2026-11-02 vigilaba #hero, y en móvil el hero apila foto,
     título, precio, tallas y botón: 2.186 px en El Beso a 375 px. La barra
     solo salía al pasar todo eso, casi tres pantallas, y quien llegaba desde
     Google Shopping veía la foto y nada más: 88 visitas de la campaña,
     83 % de rebote en móvil y 0 carritos (ledger 3457). En escritorio el
     hero cabe en una pantalla y por eso allí sí parecía funcionar.

     Ahora la barra está a la vista siempre que el botón principal no lo esté,
     por arriba o por abajo. El margen inferior es su propia altura: un botón
     escondido detrás de la barra cuenta como no visible.
     ───────────────────────────────────────────── */
  const initStickyCart = () => {
    const ancla = document.querySelector('#pa-product-form .pa-buy-row') || document.getElementById('hero');
    const sticky = document.getElementById('paStickyCart');

    if (!ancla || !sticky || !('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) {
          sticky.classList.add('is-visible');
          sticky.setAttribute('aria-hidden', 'false');
        } else {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      });
    }, {
      threshold: 0,
      rootMargin: '-80px 0px -64px 0px'
    });

    io.observe(ancla);
  };

  /* ─────────────────────────────────────────────
     JUDGE.ME — mostrar widget al hacer click
     ───────────────────────────────────────────── */
  const initReviewsToggle = () => {
    const moreLink = document.querySelector('.pa-reviews__more');
    const jmWrapper = document.getElementById('judgeme-reviews');

    if (!moreLink || !jmWrapper) return;

    moreLink.addEventListener('click', e => {
      e.preventDefault();
      jmWrapper.classList.toggle('is-visible');
      jmWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };


  /* ─────────────────────────────────────────────
     READ-MORE — descripción editorial (todos los anchos desde 2026-09-17)
     ───────────────────────────────────────────── */
  const initReadMore = () => {
    const btn = document.getElementById('paReadMore');
    const wrap = document.getElementById('paDescBody');
    if (!btn || !wrap) return;
    // Guard: evita registrar el listener dos veces si el script se carga dos veces
    if (btn._paReadMoreInit) return;
    btn._paReadMoreInit = true;

    // Conmutar y ya. Toda la logica de alturas, inline y temporizadores que
    // hubo aqui existia para animar max-height, y esa animacion dio cuatro
    // bugs seguidos (ver el comentario largo en posterarte.product.css).
    // El recorte lo hace el CSS con una clase; el JS solo la pone y la quita.
    btn.addEventListener('click', () => {
      const abrir = !wrap.classList.contains('is-expanded');
      wrap.classList.toggle('is-expanded', abrir);
      btn.textContent = abrir ? 'Leer menos' : 'Leer más';
      btn.setAttribute('aria-expanded', String(abrir));
      if (!abrir) {
        // Al recoger, devolver al usuario al principio del bloque: si no, se
        // queda mirando el hueco donde antes habia texto.
        const y = wrap.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  };

  /* ─────────────────────────────────────────────
     ZOOM DE GALERIA, sin lightbox
     El contenedor pinta la imagen de 2400 px como background y mueve
     background-position con el cursor. No abre modal, no cambia la URL
     y no interfiere con el swipe: en tactil ni se activa.
     ───────────────────────────────────────────── */
  const initZoom = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.querySelectorAll('.pa-zoom').forEach((box) => {
      if (box._paZoomInit) return;
      box._paZoomInit = true;

      const src = box.dataset.zoomSrc;
      if (!src) return;

      let cargada = false;

      const mover = (e) => {
        const r = box.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        box.style.backgroundPosition =
          Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
      };

      // La escala la decide el fichero, no un numero fijo. Con la mediana
      // del catalogo en 1500 px, un 250% sobre una caja de 640 CSS px en
      // pantalla retina pedia 3200 px a un fichero de 1500: por eso salia
      // blando. Se calcula desde naturalWidth y el devicePixelRatio y se
      // acota entre 130% y 260%. Mejora sola al subir imagenes mayores.
      const calcularEscala = (natural) => {
        const anchoCaja = box.getBoundingClientRect().width || 1;
        const dpr = window.devicePixelRatio || 1;
        const maxSinEstirar = (natural / (anchoCaja * dpr)) * 100;
        return Math.max(130, Math.min(260, maxSinEstirar));
      };

      box.addEventListener('mouseenter', () => {
        // La grande se descarga la primera vez que alguien amplia, no en
        // la carga de la pagina: no penaliza el LCP.
        if (!cargada) {
          const pre = new Image();
          pre.onload = () => {
            box.style.backgroundSize = calcularEscala(pre.naturalWidth).toFixed(0) + '%';
          };
          pre.src = src;
          box.style.backgroundImage = 'url("' + src + '")';
          cargada = true;
        }
        box.classList.add('is-zooming');
      });

      box.addEventListener('mousemove', mover);
      box.addEventListener('mouseleave', () => box.classList.remove('is-zooming'));
    });
  };

  /* ─────────────────────────────────────────────
     INIT
     ───────────────────────────────────────────── */
  const init = () => {
    initGallery();
    initZoom();
    initVariantPicker();
    initQty();
    initAddToCart();
    initFaqs();
    initStickyCart();
    initReviewsToggle();
    initReadMore();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ════════════════════════════════════════════════════════════════
   COMPARTIR — hoja nativa del sistema, con copia de enlace de reserva.

   navigator.share solo existe en contexto seguro y, en la practica, sobre
   todo en movil: ahi abre la hoja del sistema y aparecen WhatsApp, notas,
   AirDrop. En escritorio casi ningun navegador la tiene, asi que alli se
   copia el enlace y el boton lo dice durante dos segundos.

   El corazon de al lado NO se maneja aqui: es .pa-col-card__wishlist y lo
   mueve posterarte.collection.js, el mismo que las tarjetas, para que
   compartan localStorage y contador.
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function avisar(btn, texto) {
    /* Los botones son solo icono, asi que el mensaje va en una burbuja que
       pinta el CSS desde data-aviso. Antes esto cambiaba el texto de un span
       que ya no existe y el aviso no salia nunca. */
    btn.setAttribute('data-aviso', texto);
    btn.classList.add('is-copiado');
    setTimeout(function () {
      btn.classList.remove('is-copiado');
      btn.removeAttribute('data-aviso');
    }, 2000);
  }

  function copiar(url) {
    /* La Clipboard API rechaza si el documento no tiene el foco, y entonces
       el usuario se quedaba sin ninguna senal. Si falla, se cae al textarea. */
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(url).catch(function () { return copiarLegacy(url); });
    }
    return copiarLegacy(url);
  }

  function copiarLegacy(url) {
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) { /* nada que hacer */ }
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pa-hero-compartir');
    if (!btn) return;
    e.preventDefault();

    var url = window.location.href.split('#')[0];
    var titulo = btn.dataset.productoTitulo || document.title;

    if (navigator.share) {
      navigator.share({ title: titulo, text: titulo, url: url })
        .catch(function () { /* el usuario cancelo: no es un error */ });
      return;
    }
    copiar(url)
      .then(function () { avisar(btn, 'Enlace copiado'); })
      .catch(function () { avisar(btn, 'No se pudo copiar'); });
  });
})();
